const e = "cmp", n = otto.cmp, {
  allowAll: t,
  rejectAll: o,
  togglePreferenceCenter: s,
  resurfaceBanner: r,
  rejectGeneralVendorConsent: C,
  getConsentForGV: a,
  getConsentsForAllGVs: c,
  getIabConsentString: g,
  readVendorsConsents: l,
  readConsentsStates: A,
  archiveReceipt: d,
  emitConsentChangeEvent: p,
  getOttoOwnPurposesConsent: E,
  getAppGoogleTrackingConsent: S,
  getAdjustTrackingConsent: _,
  processAppConsentV2: P,
  consentChanged: i,
  showVendorsList: M,
  __loadOneTrustSDK: N,
  __oneTrustSdkReady: V
} = otto.cmp;
export {
  e as NEXUS_CMP_NAMESPACE,
  N as __loadOneTrustSDK,
  V as __oneTrustSdkReady,
  t as allowAll,
  d as archiveReceipt,
  n as cmp,
  i as consentChanged,
  p as emitConsentChangeEvent,
  _ as getAdjustTrackingConsent,
  S as getAppGoogleTrackingConsent,
  a as getConsentForGV,
  c as getConsentsForAllGVs,
  g as getIabConsentString,
  E as getOttoOwnPurposesConsent,
  P as processAppConsentV2,
  A as readConsentsStates,
  l as readVendorsConsents,
  o as rejectAll,
  C as rejectGeneralVendorConsent,
  r as resurfaceBanner,
  M as showVendorsList,
  s as togglePreferenceCenter
};
